import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { IAlertDialogData } from '../model/interfaces';
import { AlertComponent } from '../dialog/alert.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-timer-demo',
  templateUrl: './timer.component.html',
  styleUrl: './timer.component.css'
})
export class TimerComponent implements OnChanges {
  seconds: number = 0;
  timer: any;
  display: any;
  @Input() resetTime: number = 0;
  @Input() isValidFormSubmitted!: boolean;
  @Output() changeResetMessageCalled= new EventEmitter<string>();

  ngOnChanges(changes: SimpleChanges) {
    if (changes['resetTime']) {
      clearInterval(this.timer);
     let minute:number  = 15 - this.seconds/60;
      this.timerStart(minute);
    }

  }
  constructor(private dialog: MatDialog){
    this.timerStart(15);
  }

  timerStart(minute: number) {
    if(this.isValidFormSubmitted){
    clearInterval(this.timer);
    minute  = 15 - this.seconds/60;
  }

    if(this.seconds > 0){
      this.seconds = this.seconds + minute * 60;
    }else{
      this.seconds = minute * 60;
    }
    let textSec: any = "0";
    let statSec: number = 60;

    const prefix = Math.floor(this.seconds / 60) < 10 ? "0" : "";

     this.timer = setInterval(() => {
      this.seconds--;
      if (statSec != 0) statSec--;
      else statSec = 59;



      textSec = statSec.toString().padStart(2, '0');
      let minutes = (Math.floor(this.seconds / 60)).toString().padStart(2,'0');
      this.display = `${minutes}:${textSec}`;
      if (this.seconds == 60 && !this.isValidFormSubmitted) {
        this.openDialog();
      }
      if (this.seconds == 0) {
        console.log("finished");
        window.scrollTo(0, 0);
        if (!(window as any).__KARMA_TEST_MODE__) {
          window.location.reload();
        }
        clearInterval(this.timer);
      }
    }, 1000);
  }

  alertDialogData: IAlertDialogData = {
    title: 'Session Timer',
    content: `
    <br />
    <p>Your session is about to end, and your changes will not be saved. </p>
    <p> Would you like to extend your session?</p>
    <br />
        `,
    confirmButtonText: ''
  };


  openDialog() {
    const dialogRef = this.dialog.open(AlertComponent, {data: this.alertDialogData, disableClose: true });
    dialogRef.afterClosed().subscribe((result: boolean) => {
      if(result){
        clearInterval(this.timer);
        let minute:number  = 15 - this.seconds/60;
        this.timerStart(minute);
      }else if(result==false){
        this.changeResetMessageCalled.emit('resetForm');
        window.scrollTo(0, 0);
      }
    } );


  }
}
